import { pushToDataLayer } from "@lib/gtm/dataLayer";

export const CATEGORY_GUIDED_BOOKING = 'Geführte Anfrage';

export function logStep(index: string, headline: string): void {
    pushToDataLayer({
        event: 'gb_step',
        eventData: {
            label: `Schritt ${index} - ${headline}`,
            action: 'Schritt',
            category: CATEGORY_GUIDED_BOOKING
        }
    });
}

export function logClick(title: string): void {
    pushToDataLayer({
        event: 'gb_click',
        eventData: {
            label: `geklickt: ${title}`,
            action: 'Klick',
            category: CATEGORY_GUIDED_BOOKING
        }
    });
}
